const GOOGLE_MAPS_URL = 'https://www.google.com/maps/place/DASH+WASTE+Waste+Removal+%26+Recycling+Application/@-33.9587972,18.7052759,17z/data=!4m8!3m7!1s0x1dcc4fc8a5a1504d:0x5f44d0cb871644f4!8m2!3d-33.9587972!4d18.7052759!9m1!1b1!16s%2Fg%2F11ry7vbm5l';

const site = {
  brandName: 'Dash Waste',
  legalName: 'WRAPP WASTE Technologies Pty Ltd',
  siteName: 'Dash Waste',
  origin: 'https://dashwaste.co.za',
  appOrigin: 'https://app.dashwaste.co.za',
  driverSignupUrl: 'https://app.wrappwaste.com/driver-signup',
  contentLastmod: '2026-05-29',
  phone: '+27722459777',
  phoneDisplay: '072 245 9777',
  email: 'info@dashwaste.co.za',
  salesEmail: 'sales@dashwaste.co.za',
  address: {
    streetAddress: '36 Zinfandal Rd',
    addressLocality: 'Blackheath',
    addressRegion: 'Cape Town',
    addressCountry: 'ZA'
  },
  registrationNumber: '2007/008 563/07',
  vatNumber: '463 027 9224',
  foundedStatement: 'Dash Waste has been in the waste business since 2007.',
  serviceAreas: ['Cape Town', 'Boland', 'Johannesburg', 'Pretoria'],
  areaQualifier: 'Availability is confirmed by entering the waste location or postal code in the online quote flow.',
  sameAs: [
    'https://www.facebook.com/wrappwaste',
    'https://www.instagram.com/dashwaste/',
    'https://www.trustpilot.com/review/dashwaste.co.za',
    GOOGLE_MAPS_URL
  ],
  trustSignals: [
    'Institute of Waste Management since 2009',
    'Accredited City of Cape Town Provider since 2016',
    "Master Builders and Allied Traders' Association since 2021",
    'Umthi Initiatives since 2020',
    'Peach Payments gateway since 2007'
  ],
  paymentFacts: [
    'Debit and credit card registration is handled through Peach Payments.',
    'Visa and MasterCard are accepted.',
    'EFT is available using the banking details shown in the help content.'
  ]
};

const bookingSteps = [
  'Enter the waste location so Dash Waste can check area availability.',
  'Choose the waste type and available service or bin type.',
  'Send contact details to receive the quote and continue the booking flow.'
];

const services = [
  {
    slug: 'skip-bin-hire',
    path: '/services/skip-bin-hire',
    name: 'Skip Bin Hire',
    serviceType: 'Skip bin hire',
    h1: 'Skip bin hire through Dash Waste',
    shortDescription: 'Book skip bins, roro bins or trucks online, subject to waste type and address availability.',
    description: 'Dash Waste helps customers book skip bins, roro bins and waste trucks online. Enter the waste location first so the platform can show the waste types and service options available for that postal code.',
    bestFor: [
      'Home cleanups and renovations',
      'Building rubble where a container is more practical than loose loading',
      'Garden refuse and general waste, depending on address and waste type availability'
    ],
    wasteTypes: ['General waste', 'Clean building rubble', 'Garden refuse', 'Recyclables'],
    containers: ['Skip bins', 'Roro bins', 'Tipper trucks'],
    bookingNotes: [
      'The quote flow checks the address or postal code before showing available products.',
      'Bin rental is shown in the FAQ as 1 to 7 days, with monthly rentals handled by contacting Dash Waste.',
      'Delivery, exchange and collection options depend on the selected vehicle and waste type.'
    ],
    faqs: [
      {
        question: 'Can I book a skip bin online?',
        answer: 'Yes. Start with the waste location, then choose the available waste type and container option for that area.'
      },
      {
        question: 'How long can I keep the bin?',
        answer: 'The existing FAQ states bin rental is 1 to 7 days. Contact Dash Waste for monthly rentals.'
      }
    ]
  },
  {
    slug: 'building-rubble-removal',
    path: '/services/building-rubble-removal',
    name: 'Building Rubble Removal',
    serviceType: 'Building rubble removal',
    h1: 'Building rubble removal',
    shortDescription: 'Book rubble removal for clean building rubble such as sand, stone, concrete, cement, bricks and tiles.',
    description: 'Dash Waste supports rubble removal bookings for clean building rubble. The public waste-type guidance lists sand, stone, concrete, cement, bricks and tiles as clean building rubble.',
    bestFor: [
      'Renovation and building rubble',
      'Concrete, cement, bricks, tiles, stone and sand',
      'Customers who need a tracked quote and booking record'
    ],
    wasteTypes: ['Clean building rubble', 'Mixed building rubble where available in the quote flow'],
    containers: ['Skip bins', 'Roro bins', 'Tipper trucks'],
    bookingNotes: [
      'Enter the waste location before choosing rubble removal options.',
      'The quote flow shows only waste types and vehicles available for the selected postal code.',
      'Disposal is handled by independent service providers through the Dash Waste platform.'
    ],
    faqs: [
      {
        question: 'What counts as clean building rubble?',
        answer: 'The public guidance lists sand, stone, concrete, cement, bricks and tiles.'
      },
      {
        question: 'Can I get a rubble removal quote without calling?',
        answer: 'Yes. Enter the waste location in the fast quote flow to check available services for that area.'
      }
    ]
  },
  {
    slug: 'garden-refuse-removal',
    path: '/services/garden-refuse-removal',
    name: 'Garden Refuse Removal',
    serviceType: 'Garden refuse removal',
    h1: 'Garden refuse removal',
    shortDescription: 'Book garden refuse removal for branches, grass, leaves and stumps.',
    description: 'Dash Waste lists garden refuse as branches, grass, leaves and stumps. Availability depends on the waste location and postal code entered in the quote flow.',
    bestFor: [
      'Garden cleanups',
      'Branches, leaves, grass and stumps',
      'Customers comparing container or truck options for a specific address'
    ],
    wasteTypes: ['Garden refuse'],
    containers: ['Skip bins', 'Tipper trucks'],
    bookingNotes: [
      'Use the online quote flow to check whether garden refuse removal is available at the waste location.',
      'If the location is not currently serviced, the app prompts customers to contact Dash Waste by phone.'
    ],
    faqs: [
      {
        question: 'What garden waste can I book for?',
        answer: 'The public guidance lists branches, grass, leaves and stumps.'
      }
    ]
  },
  {
    slug: 'general-waste-removal',
    path: '/services/general-waste-removal',
    name: 'General Waste Removal',
    serviceType: 'General waste removal',
    h1: 'General waste removal',
    shortDescription: 'Book general waste services for commercial, light industrial and domestic waste.',
    description: 'Dash Waste describes general waste as commercial, light industrial and domestic waste such as wood, papers, plastics, cardboard, metals and textiles.',
    bestFor: [
      'Commercial and light industrial waste',
      'Domestic waste that needs a booked collection service',
      'Wood, paper, plastics, cardboard, metals and textiles where accepted'
    ],
    wasteTypes: ['General waste'],
    containers: ['Skip bins', 'Roro bins', 'Tipper trucks'],
    bookingNotes: [
      'Enter the address first so the platform can show service options for that postal code.',
      'The quote flow captures a mobile number and email address before submitting the quote request.'
    ],
    faqs: [
      {
        question: 'What does Dash Waste list as general waste?',
        answer: 'Commercial, light industrial and domestic waste such as wood, papers, plastics, cardboard, metals and textiles.'
      }
    ]
  }
];

const pages = [
  {
    path: '/',
    key: 'home',
    title: 'Dash Waste | Waste Removal, Skip Bin Hire and Rubble Removal',
    description: 'Book waste removal, skip bins, roro bins and trucks online with Dash Waste. Check availability by address for Cape Town, Boland, Johannesburg and Pretoria.',
    h1: 'Book waste removal, skip bins, roros or trucks online',
    robots: 'index,follow',
    priority: '1.0',
    changefreq: 'weekly',
    cta: 'Get quote',
    sections: [
      {
        heading: 'What Dash Waste does',
        body: 'Dash Waste is a South African-born platform that connects customers with independent truck owners, local service providers and loading teams for waste removal, transport, disposal and recycling services.'
      },
      {
        heading: 'Service availability',
        body: 'The public FAQ lists current service centres as Cape Town, Boland, Johannesburg and Pretoria. Availability is confirmed by entering the waste address or postal code in the quote flow.'
      },
      {
        heading: 'How booking works',
        body: 'Enter the waste location, choose a waste type and available service, then submit contact details to receive the quote and continue the booking.'
      }
    ]
  },
  {
    path: '/help',
    key: 'help',
    title: 'Waste Removal FAQs | Dash Waste Help',
    description: 'Answers about Dash Waste bookings, service areas, waste types, payment, bin rental, accredited partners and service-provider signup.',
    h1: 'Dash Waste FAQs',
    robots: 'index,follow',
    priority: '0.8',
    changefreq: 'monthly',
    cta: 'Call Dash Waste',
    sections: [
      {
        heading: 'Core help topics',
        body: 'The help page covers how to book, how Dash Waste works, card and EFT payment, service areas, waste type selection, product selection, bin rental and service-provider signup.'
      },
      {
        heading: 'Contact',
        body: 'Customers can call 072 245 9777 or email info@dashwaste.co.za.'
      }
    ]
  },
  {
    path: '/about',
    key: 'about',
    title: 'About Dash Waste | WRAPP WASTE Technologies',
    description: 'Dash Waste is a South African-born waste-removal platform by WRAPP WASTE Technologies Pty Ltd, with head office in Blackheath, Cape Town.',
    h1: 'About Dash Waste',
    robots: 'index,follow',
    priority: '0.7',
    changefreq: 'monthly',
    sections: [
      {
        heading: 'Company overview',
        body: 'Dash Waste makes waste removal simple, transparent and dependable by bringing independent truck owners and customers together through its application.'
      },
      {
        heading: 'Business details',
        body: 'Head Office: 36 Zinfandal Rd, Blackheath, Cape Town, South Africa. Registration Number: 2007/008 563/07. VAT Number: 463 027 9224.'
      }
    ]
  },
  {
    path: '/driver',
    key: 'driver',
    title: 'Become a Dash Waste Service Provider',
    description: 'Independent waste service providers can sign up, meet Dash Waste, get approved, receive bookings and get paid bi-weekly.',
    h1: 'Become a Service Provider',
    robots: 'index,follow',
    priority: '0.8',
    changefreq: 'monthly',
    cta: 'Sign up as a service provider',
    sections: [
      {
        heading: 'Provider process',
        body: 'The public driver page lists the steps as sign up, meet Dash Waste, get approved, show paperwork and equipment, then service clients and get paid bi-weekly.'
      },
      {
        heading: 'Provider requirements',
        body: 'The page asks providers for a driver licence, valid PDP, roadworthy truck, waste management accreditation and proof of waste disposal.'
      }
    ]
  },
  {
    path: '/tc',
    key: 'terms',
    title: 'Terms of Use | Dash Waste',
    description: 'Dash Waste terms of use for customers and service users in South Africa.',
    h1: 'Terms of Use',
    robots: 'index,follow',
    priority: '0.3',
    changefreq: 'yearly',
    sections: [
      {
        heading: 'Terms summary',
        body: 'The terms cover access to Dash Waste services, accounts, payment, user conduct, liability and notices.'
      }
    ]
  }
].concat(services.map((service) => ({
  path: service.path,
  key: `service-${service.slug}`,
  type: 'service',
  serviceSlug: service.slug,
  title: `${service.name} | Dash Waste`,
  description: service.shortDescription,
  h1: service.h1,
  robots: 'index,follow',
  priority: '0.8',
  changefreq: 'monthly',
  cta: 'Start a quote',
  sections: [
    {
      heading: 'Service overview',
      body: service.description
    },
    {
      heading: 'Availability',
      body: site.areaQualifier
    }
  ]
})));

const faqItems = [
  {
    question: 'What areas does Dash Waste service?',
    answer: 'The public FAQ lists current service centres as Cape Town, Boland, Johannesburg and Pretoria. Availability is checked by entering the waste location or postal code.'
  },
  {
    question: 'What waste types are listed?',
    answer: 'The public content lists clean building rubble, recycling, general waste, plate glass, garden refuse and liquid waste.'
  },
  {
    question: 'How do I book?',
    answer: 'Sign up or start the fast quote flow, enter the waste location, choose waste and service types, then submit contact details.'
  },
  {
    question: 'How do I pay?',
    answer: 'The public help content lists debit or credit card via Peach Payments and EFT.'
  }
];

function getServiceBySlug(slug) {
  return services.find((service) => service.slug === slug);
}

function getPageByPath(path) {
  const normalizedPath = (path || '/').replace(/\/+$/, '') || '/';
  return pages.find((page) => page.path === normalizedPath);
}

module.exports = {
  site,
  services,
  pages,
  faqItems,
  bookingSteps,
  getServiceBySlug,
  getPageByPath
};
